import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, Box } from "@mui/material";

import theme from "./theme/theme";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import AppRoutes from "./routes/AppRoutes";

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "background.default",
                }}
            >
                <Header />
                <Box component="main" sx={{ flexGrow: 1 }}>
                    <AppRoutes />
                </Box>
                <Footer />
            </Box>
        </ThemeProvider>
    );
}

export default App;
